import React from 'react';
import ReactDropzone from 'react-dropzone';
import { observer } from 'mobx-react';
import { isSome } from 'core/utils';

function BaasicDropzoneTemplate({ acceptFiles, onFilesDrop, placeholder }) {
	return (
		<ReactDropzone className="react-dropzone__box " accept={acceptFiles} onDrop={onFilesDrop}>
			<div className="react-dropzone__item">
				<div className="react-dropzone__add">
					<i className="react-dropzone__add__icon fa fa-plus-circle"></i>
					{placeholder != null && <p>{shortenPlaceholder(placeholder, 50)}</p>}
				</div>
			</div>
		</ReactDropzone>
	);
}

function shortenPlaceholder(placeholder, numberOfCharacters) {
	if (isSome(placeholder) && placeholder.length > numberOfCharacters) {
		const length = placeholder.length;
		const firstPart = placeholder.slice(0, (numberOfCharacters / 2) - 1);
		const secondPart = placeholder.slice(length - (numberOfCharacters / 2) - 1, length);
		return firstPart + " . . . " + secondPart;
	}
	return placeholder;
}

export default observer(BaasicDropzoneTemplate);
